require('./../../lib/src/client-entry-setup');
require('./../../lib/src-client/example-script');



//////////////////
// WEBPACK FOOTER
// ./deployment/resources/example-script.source.js
// module id = 13
// module chunks = 0